import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { Link, Util, ToggleGroup } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { usePaymentSlots } from '../../slots/context.js';

const DonationFormComponent = ({ name , options: options1 , onClick , initialValue , foundationKey , isBrandNotSupportedForDonation  })=>{
    const { getLabel , locale , currency  } = useIntl();
    const { Slots  } = usePaymentSlots();
    const [isTermsModalOpen, setIsTermsModalOpen] = React.useState(false);
    const [isInfoModalOpen, setIsInfoModalOpen] = React.useState(false);
    React.useEffect(()=>{
        if (typeof isBrandNotSupportedForDonation !== 'undefined' && isBrandNotSupportedForDonation) {
            onClick(foundationKey, undefined);
        }
    }, [
        isBrandNotSupportedForDonation,
        foundationKey,
        onClick
    ]);
    const formatOptions = (options)=>options.map((value)=>({
                value,
                label: formatPrice({
                    locale,
                    value,
                    currency,
                    isCentAmount: true
                })
            })
        )
    ;
    const pushDonationModalEventToDataLayer = (interactionType)=>{
        DataLayer.pushEvent({
            event: 'donations_click',
            site_feature: 'donations',
            interaction_type: interactionType,
            foundation_key: foundationKey
        });
    };
    const handleDonationInfoToggle = ()=>{
        if (!isInfoModalOpen) {
            pushDonationModalEventToDataLayer('information');
        }
        setIsInfoModalOpen(!isInfoModalOpen);
    };
    const handleDonationTermsToggle = ()=>{
        if (!isTermsModalOpen) {
            pushDonationModalEventToDataLayer('terms');
        }
        setIsTermsModalOpen(!isTermsModalOpen);
    };
    const handleClick = (option)=>{
        onClick(foundationKey, option === null || option === void 0 ? void 0 : option.value);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, Slots.DonationTermsModal && /*#__PURE__*/ React.createElement(Slots.DonationTermsModal, {
        isOpen: isTermsModalOpen,
        onClose: handleDonationTermsToggle
    }), Slots.DonationInfoModal && /*#__PURE__*/ React.createElement(Slots.DonationInfoModal, {
        isOpen: isInfoModalOpen,
        onClose: handleDonationInfoToggle
    }), /*#__PURE__*/ React.createElement("div", {
        className: "donation-form-component"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "p",
        className: "donation-form-component__heading"
    }, getLabel('checkout.payment.donation.title')), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "p",
        className: "donation-form-component__description"
    }, getLabel('checkout.payment.donation.description'), "\xa0", /*#__PURE__*/ React.createElement(Link, {
        onClick: handleDonationInfoToggle,
        className: "donation-form-component__link"
    }, getLabel('checkout.payment.donation.learn_more'))), /*#__PURE__*/ React.createElement("div", {
        className: "donation-form-component__logo"
    }, Util.getDonationFoundationIcon(foundationKey)), isBrandNotSupportedForDonation ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default donation-form-component__alert"
    }, getLabel('checkout.payment.donation.unsupportedBrand')) : /*#__PURE__*/ React.createElement("div", {
        className: "donation-form-component__options"
    }, /*#__PURE__*/ React.createElement(ToggleGroup, {
        name: name,
        options: formatOptions(options1),
        onClick: handleClick,
        initialValue: initialValue
    })), /*#__PURE__*/ React.createElement("div", {
        className: "donation-form-component__terms-and-conditions"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        color: "text-secondary"
    }, getLabel('checkout.payment.donation.termsText'), "\xa0", /*#__PURE__*/ React.createElement(Link, {
        onClick: handleDonationTermsToggle,
        className: "donation-form-component__link"
    }, getLabel('checkout.payment.donation.terms'))))));
};

export { DonationFormComponent };
//# sourceMappingURL=DonationFormComponent.js.map
